import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  width: 100%;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import { StyledDivider } from "./HandoutProductDetailContent.style";
const SectionWithDividerContainer = styled.div.withConfig({
    componentId: "sc-c7f2203c-0"
})(_templateObject());
export const SectionWithDivider = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ _jsxs(SectionWithDividerContainer, {
        children: [
            /*#__PURE__*/ _jsx(StyledDivider, {}),
            children
        ]
    });
};
